import { render, staticRenderFns } from "./homeTwo.vue?vue&type=template&id=12496d26&scoped=true&"
import script from "./homeTwo.vue?vue&type=script&lang=js&"
export * from "./homeTwo.vue?vue&type=script&lang=js&"
import style0 from "./homeTwo.vue?vue&type=style&index=0&id=12496d26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12496d26",
  null
  
)

export default component.exports